module.exports = __webpack_public_path__ + "static/img/2018@2x.a274004.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2018@2x.png
// module id = nu/n
// module chunks = 1